var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{attrs:{"header":(_vm.itemdescription + " | " + _vm.person)}},[_c('td',[_vm._v(_vm._s(_vm.itemdescription)+" | "+_vm._s(_vm.person))]),_c('td',{class:{
      'text-danger': _vm.product.l_IC_F !== 'OK',
      'text-success': _vm.product.l_IC_F === 'OK',
    }},[_vm._v(" "+_vm._s(_vm.product.l_IC_F)+" ")]),_c('td',[(_vm.product.lfc !== false)?_c('form-element',{attrs:{"form-element":{
        type: 'select',
        name: 'productLeft',
        options: _vm.options,
        placeholder: _vm.$t('productLeft'),
        hideLabel: true,
        required: true,
        selectLabel: 'key',
        size: 12,
      }},on:{"input":function($event){return _vm.handleProductStatusChange($event)}},model:{value:(_vm.product.lfc),callback:function ($$v) {_vm.$set(_vm.product, "lfc", $$v)},expression:"product.lfc"}}):_vm._e()],1),_c('td',{class:{
      'text-danger': _vm.product.r_IC_F !== 'OK',
      'text-success': _vm.product.r_IC_F === 'OK',
    }},[_vm._v(" "+_vm._s(_vm.product.r_IC_F)+" ")]),_c('td',[(_vm.product.rfc !== false)?_c('form-element',{attrs:{"form-element":{
        type: 'select',
        name: 'productRight',
        options: _vm.options,
        placeholder: _vm.$t('productRight'),
        hideLabel: true,
        required: true,
        selectLabel: 'key',
        size: 12,
      }},on:{"input":function($event){return _vm.handleProductStatusChange($event)}},model:{value:(_vm.product.rfc),callback:function ($$v) {_vm.$set(_vm.product, "rfc", $$v)},expression:"product.rfc"}}):_vm._e()],1),_c('td',[(_vm.product.itemID === '10000' || _vm.product.itemID === '10115')?_c('form-element',{attrs:{"form-element":{
        type: 'select',
        name: 'attenuation',
        options: _vm.attenuationOptions,
        placeholder: _vm.$t('attenuation'),
        hideLabel: true,
        required: true,
        selectLabel: 'label',
        size: 12,
      }},model:{value:(_vm.product.r_Attenuation),callback:function ($$v) {_vm.$set(_vm.product, "r_Attenuation", $$v)},expression:"product.r_Attenuation"}}):_c('div',{staticClass:"text-center"},[_vm._v("N/A")])],1),_c('td',[_c('b-form-checkbox',{attrs:{"name":"repair","disabled":_vm.commentFieldRequired,"unchecked-value":false,"value":true},model:{value:(_vm.product.repair),callback:function ($$v) {_vm.$set(_vm.product, "repair", $$v)},expression:"product.repair"}})],1),_c('td',[(_vm.product.lfc || _vm.product.rfc)?_c('form-element',{attrs:{"form-element":{
        type: 'text',
        name: 'comment',
        options: _vm.options,
        placeholder: _vm.$t('comment'),
        hideLabel: true,
        required: _vm.commentFieldRequired,
        size: 12,
        maxLength: 178, // Max 200 minus the default text in case of repair. See the RepairProduct method in FunctionControlHandler.cs (App_Code).
      }},model:{value:(_vm.product.comment),callback:function ($$v) {_vm.$set(_vm.product, "comment", $$v)},expression:"product.comment"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }